/* LA Flight School :: homepage Hangar Doors 2A.
   v76: the hero runs at every width (it replaced ef-hero on desktop too); the rest of the 2A page is
   phone-only and simply hidden on wider screens.
   - hangar doors: scroll drives --p1/--p2/--c on .hx (same maths as the approved prototype)
   - --m2a-off: how far the hero starts below the top of the page (the promo band on desktop), so the
     closed-door content clears the bottom of the first screen
   - header hand-over: the site header stays hidden while the doors are on screen, then html.m2a-nav-on
     and html.tkv-nav-on are set (la-header already uses tkv-nav-on to retire the round menu button)
   - tabs, swipe dots, avatar marquee, offer days-left, consultation pop-up */
(function () {
  if (window.__m2aHome) return; window.__m2aHome = 1;
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- hangar doors + header hand-over ---------- */
  var heroes = all('.m2a .hx');
  var navOn = null;
  function headers() { return all('#laHeader, .la-header, .shopify-section-group-header-group'); }
  function setNav(on) {
    if (on === navOn) return;
    navOn = on;
    doc.classList.toggle('tkv-nav-on', on);
    doc.classList.toggle('m2a-nav-on', on);
    /* ef-hero hides the header with an inline style; on phones it no longer runs, but if the
       window was resized from desktop the inline style may still be there. */
    if (on) headers().forEach(function (el) { el.style.removeProperty('display'); });
  }
  function offsets() {
    heroes.forEach(function (h) {
      var top = h.getBoundingClientRect().top + (window.pageYOffset || doc.scrollTop || 0);
      h.style.setProperty('--m2a-off', Math.max(0, Math.round(top)) + 'px');
    });
  }
  function tick() {
    heroes.forEach(function (h) {
      if (reduce) { h.style.setProperty('--p1', 1); h.style.setProperty('--p2', 1); h.style.setProperty('--c', 1); h.classList.add('live'); return; }
      var r = h.getBoundingClientRect(), stage = h.querySelector('.hx-stage');
      var total = Math.max(1, h.offsetHeight - stage.offsetHeight);
      var p = clamp(-r.top / total, 0, 1);
      var o = parseFloat(h.getAttribute('data-open') || '.5');
      var p1 = ease(clamp(p / o, 0, 1));
      var p2 = clamp((p - o * .35) / (1 - o * .35), 0, 1);
      var c = clamp((p - o * .7) / .3, 0, 1);
      h.style.setProperty('--p1', p1.toFixed(4));
      h.style.setProperty('--p2', p2.toFixed(4));
      h.style.setProperty('--c', c.toFixed(4));
      h.classList.toggle('live', c > .55);
      h.classList.toggle('closed', p1 < .25);
    });
    var h0 = heroes[0];
    if (h0) setNav(h0.getBoundingClientRect().bottom <= window.innerHeight + 1);
  }
  var queued = false;
  function onScroll() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; tick(); }); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { offsets(); onScroll(); });
  window.addEventListener('load', function () { offsets(); onScroll(); });
  offsets();
  tick();

  /* ---------- avatar marquee: duplicate the row once for a seamless loop ---------- */
  all('.m2a [data-loop]').forEach(function (row) {
    all(':scope > *', row).forEach(function (k) {
      var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('id');
      all('a,button', c).forEach(function (a) { a.tabIndex = -1; });
      row.appendChild(c);
    });
  });

  /* ---------- offers: days left (the Liquid hides the whole offer after Oct 31) ---------- */
  var END = Date.parse('2026-11-01T06:59:59Z');
  all('.m2a [data-days-left]').forEach(function (el) {
    var d = Math.max(0, Math.ceil((END - Date.now()) / 864e5));
    el.textContent = d + (d === 1 ? ' Day' : ' Days');
  });

  /* ---------- tabs ---------- */
  all('.m2a [data-tabs]').forEach(function (group) {
    var btns = all('[role="tab"]', group);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (j === null) return;
        e.preventDefault(); var n = btns[(j + btns.length) % btns.length]; select(n); n.focus();
      });
    });
    function select(b) {
      btns.forEach(function (x) {
        var on = x === b;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
    btns.forEach(function (x) { x.tabIndex = x.getAttribute('aria-selected') === 'true' ? 0 : -1; });
  });

  /* ---------- swipe dots ---------- */
  all('.m2a [data-dots]').forEach(function (list) {
    var dots = document.getElementById(list.getAttribute('data-dots')); if (!dots) return;
    var n = list.children.length; dots.innerHTML = new Array(n + 1).join('<i></i>');
    function upd() {
      var i = Math.round(list.scrollLeft / (list.scrollWidth - list.clientWidth || 1) * (n - 1));
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
    }
    list.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* ---------- free consultation: open the Cowlendar pop-up in place ----------
     Cowlendar binds only to anchors that were in the server-rendered HTML, so the section
     prints one native anchor off-screen; the visible buttons click it. If no pop-up shows
     within about 6 seconds the button simply opens the consultation page. */
  all('[data-m2a-natives]').forEach(function (box) { box.addEventListener('click', function (e) { e.preventDefault(); }); });
  function modalOpen() {
    if (document.body.classList.contains('cowlendar-overflow-fixed')) return true;
    if (document.querySelector('.cowlendar-iframe,.cow-modal.cow-open')) return true;
    var b = document.querySelector('.cowlendar-bg,.cowlendar-modal');
    return !!(b && b.offsetParent !== null && getComputedStyle(b).display !== 'none');
  }
  document.addEventListener('click', function (e) {
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('.m2a [data-m2a-consult]');
    if (!a) return;
    var n = document.querySelector('[data-m2a-native="consult"]');
    if (!n) return; /* no native anchor: follow the link */
    e.preventDefault();
    var href = a.getAttribute('href'), tries = 0;
    a.classList.add('is-busy');
    (function attempt() {
      if (modalOpen()) { a.classList.remove('is-busy'); return; }
      if (tries < 4) { tries++; try { n.click(); } catch (err) {} setTimeout(attempt, 1600); return; }
      a.classList.remove('is-busy');
      if (href) location.assign(href);
    })();
  });
})();
